import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setOffers, setLoading, setError } from './p2pSlice';
import P2PMarketplaceService from '../../services/p2pMarketplace.service';

export const LoadP2POffers = () => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.p2p?.filters);

  const { refetch } = useQuery(
    ["p2p-offers", filters],
    async () => {
      dispatch(setLoading(true));
      const res = await P2PMarketplaceService.getOffers(filters);
      return res;
    },
    {
      enabled: true,
      refetchInterval: 30000,
      onSuccess: (res) => {
        const offers =
          res?.data?.offers ||
          res?.offers ||
          res?.data ||
          [];
        // Debug: show filters and offers count
        try { console.debug('[P2P] Offers loaded', { filters, count: Array.isArray(offers) ? offers.length : 0 }); } catch {}
        dispatch(setOffers(Array.isArray(offers) ? offers : []));
        dispatch(setLoading(false));
        dispatch(setError(null));
      },
      onError: (err) => {
        dispatch(setLoading(false));
        dispatch(setError(err?.response?.data?.message || 'Failed to load P2P offers.'));
        console.error('Failed to load P2P offers:', err);
      },
    }
  );

  useEffect(() => {
    // expose manual refresher and run once
    window.refreshP2POffers = () => refetch();
    refetch();
  }, [refetch, filters]);

  return null;
};

export default LoadP2POffers;
